module.exports = __webpack_public_path__ + "img/maledark.67734166.svg";